import { Environment, getSubdomain, isCloverProdEnvironment, isDevHost } from 'util/Environment';

const hostName: string = getSubdomain();

const scriptMap: Record<Environment, string | Record<string, string>> = {
  test: 'https://checkout.dev1.dev.clover.com/sdk.js',
  // since all dev*, stg* and sandbox use prod build, hence keeping them inside production
  production: {
    clover: 'https://checkout.clover.com/sdk.js',
    dev1: 'https://checkout.dev1.dev.clover.com/sdk.js',
    dev24: 'https://checkout.dev24.dev.clover.com/sdk.js',
    sandbox: 'https://checkout.sandbox.dev.clover.com/sdk.js',
    stg1: 'https://checkout.stg1.dev.clover.com/sdk.js',
    stg7: 'https://checkout.stg7.dev.clover.com/sdk.js',
    staging: 'https://checkout.staging.clover.com/sdk.js'
  },
  development: 'https://checkout.dev1.dev.clover.com/sdk.js'
} as const;

const getScriptUrl = (environment: Environment): string => {
  if (environment === 'production') {
    const productionMap = scriptMap[environment] as Record<string, string>;
    // return dev1 script url for netlify or any other dev host
    if (isDevHost()) {
      return productionMap['dev1'];
    }

    if (isCloverProdEnvironment()) {
      return productionMap['clover'];
    }

    const isEnvironmentPresent = Object.keys(productionMap).includes(hostName);
    if (!isEnvironmentPresent) {
      console.error(`Tokenization not configured for ${hostName} environment`);
    }

    return productionMap[hostName];
  }

  return scriptMap[environment] as string;
};

const pakmsKeyMap: Record<Environment, string | Record<string, string>> = {
  test: '7e525404872b8186b82b5057cfacebff',
  // since all dev*, stg* and sandbox use prod build, hence keeping them inside production.
  production:  {
    clover: '54fc1bcf010bdeff7a8ca63ca20478c9',
    dev1: '7e525404872b8186b82b5057cfacebff',
    dev24: '7e525404872b8186b82b5057cfacebff',
    // TODO need to change this once generated for sandbox
    sandbox: '7e525404872b8186b82b5057cfacebff',
    stg1: '7e525404872b8186b82b5057cfacebff',
    stg7: 'a8234e816254d97ed9d41bbc7b318b59',
    staging:'7e525404872b8186b82b5057cfacebff'
  },
  development: '7e525404872b8186b82b5057cfacebff'
};

const getPakmsKey = (environment: Environment): string => {
  if (environment === 'production') {
    const productionMap = pakmsKeyMap[environment] as Record<string, string>;
    if (isDevHost()) {
      return productionMap['dev1'];
    }

    if (isCloverProdEnvironment()) {
      return productionMap['clover'];
    }

    const isEnvironmentPresent = Object.keys(productionMap).includes(hostName);
    if (!isEnvironmentPresent) {
      console.error(`Pakms key not configured for ${hostName} environment`);
    }

    return productionMap[hostName];
  }

  return pakmsKeyMap[environment] as string;
};

export {
  getPakmsKey,
  getScriptUrl,
};

